export default function IconApplicationStep1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-5bf89aa6-7fd8-4e50-8632-5a1c181e6051"
      data-name="Layer 2"
      viewBox="0 0 48.372 60"
    >
      <defs>
        <style>
          {
            ".uuid-b9f5d3f7-65cf-4eee-91d2-fd4d141157ce{fill:var(--color-primary);stroke-width:0}"
          }
        </style>
      </defs>
      <g id="uuid-d0721975-1c5f-4f87-b7a7-186ed8ae1d9a" data-name="Layer 1">
        <g id="uuid-8c8a0222-d220-42a1-82e4-4aa638dc6064" data-name="g1386">
          <g id="uuid-079a99f2-dbce-405f-930b-0f1501a5d91e" data-name="g1388">
            <path
              id="uuid-c8442f49-86a5-4bcf-8954-b0d9104f58a0"
              d="M9.03 0 0 9.286V60h48.372V0H9.03ZM3.515 13.438h9.921V3.515h31.42v52.968H3.515V13.437Zm6.406-9.313v5.797H4.285l5.637-5.797Z"
              className="uuid-b9f5d3f7-65cf-4eee-91d2-fd4d141157ce"
              data-name="path1390"
            />
          </g>
          <g id="uuid-9a9b4c4c-80c0-47da-9fd4-ed6428d71e43" data-name="g1392">
            <path
              id="uuid-c9baf200-67f5-4eb5-ba25-fde791d08720"
              d="m13.23 46.264-2.508-2.507-2.486 2.486 4.993 4.993 7.493-7.493-2.486-2.486-5.007 5.007Z"
              className="uuid-b9f5d3f7-65cf-4eee-91d2-fd4d141157ce"
              data-name="path1394"
            />
          </g>
          <path
            id="uuid-d4abbcb4-5aa8-41cb-a2ab-6f248869f3ff"
            d="M24.186 49.258h16.25v-3.516h-16.25v3.516Z"
            className="uuid-b9f5d3f7-65cf-4eee-91d2-fd4d141157ce"
            data-name="path1396"
          />
          <g id="uuid-24c2d875-d4a4-402a-a7a5-0851ca13263a" data-name="g1398">
            <g id="uuid-b67ef179-00a2-4bfd-9f0f-ae078fada93a" data-name="g1400">
              <g
                id="uuid-f6abd9a7-0878-44b2-8dfd-f9685c097902"
                data-name="g1406"
              >
                <path
                  id="uuid-600aae53-0204-43d2-8aa2-e371563b763c"
                  d="M16.353 34.492c.803-3.584 4.01-6.27 7.833-6.27s7.03 2.686 7.833 6.27H16.353Zm13.036-15c0 2.87-2.334 5.203-5.203 5.203s-5.203-2.334-5.203-5.202 2.334-5.203 5.203-5.203 5.203 2.334 5.203 5.203m-10.808 6.67c-3.539 1.974-5.938 5.755-5.938 10.087v1.758H35.73V36.25c0-4.332-2.399-8.113-5.937-10.087a8.702 8.702 0 0 0 3.112-6.67c0-4.808-3.91-8.719-8.718-8.719s-8.718 3.911-8.718 8.719a8.702 8.702 0 0 0 3.112 6.67"
                  className="uuid-b9f5d3f7-65cf-4eee-91d2-fd4d141157ce"
                  data-name="path1408"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
